<template>
  <div class="sauces-details-component d-flex align-center j-between">
    <v-btn @click="openSaucesCategory" class="button-param" color="#4CAF50" depressed>
      <font-awesome-icon icon="plus" />
    </v-btn>
    <span class="status-text">Предложить соус</span>
    <div @click="setDetailStatus"
         class="status d-flex align-center justify-center"
         :class="{'active': isSauceSuggested}"
    >
      <font-awesome-icon icon="check" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'SaucesDetails',
    computed: {
      ...mapState({
        isSauceSuggested: state => state.fastOrder.isSauceSuggested,
        categories: state => state.categories.categoriesList,
      }),
    },
    methods: {
      setDetailStatus () {
        this.$store.commit('fastOrder/setSauceDetailsStatus', true)
      },
      openSaucesCategory () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', 'sauces')
      },
      changeCategory (id) {
        this.$store.commit('newOrder/setMenuItemsLoading', true)
        this.$store
          .dispatch('categories/fetchFilialMenuSingleCategories', { id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit(
                'newOrder/setMenuItemsList',
                res.data.data.menuItems,
              )
              this.$store.commit(
                'newOrder/setCollectionsList',
                res.data.data.collections,
              )
            }
            this.$store.commit('newOrder/setCurrentCollectionId', undefined)
            this.$store.commit('newOrder/setMenuItemsLoading', false)
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  .sauces-details-component {
    padding: 12px 13px;
    margin-bottom: 12px;
    background-color: #e6f2e6;
    border-radius: 10px;

    .button-param {
      margin-right: 20px;

      svg {
        .fill-svg(#ffffff);
      }
    }

    .button-param {
      font-size: 25px;
      line-height: 1;
      width: 50px;
      height: 50px;
      min-width: 50px !important;
      padding: 0 !important;
    }

    .status {
      flex-shrink: 0;
      background-color: #c3e2c3;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      cursor: pointer;
      &.active {
        background-color: #4CAF50;
      }

      svg {
        width: 23px;
        height: 23px;
        .fill-svg(#ffffff);
      }
    }
  }
</style>
